import { render, staticRenderFns } from "./emergencyuser.vue?vue&type=template&id=d4b435da&scoped=true"
import script from "./emergencyuser.vue?vue&type=script&lang=js"
export * from "./emergencyuser.vue?vue&type=script&lang=js"
import style0 from "./emergencyuser.vue?vue&type=style&index=0&id=d4b435da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b435da",
  null
  
)

export default component.exports